/* Custom Dropdown Menu
 * Items with "#" prefix become sub-items of the previous item
 */
(function() {
    'use strict';

    // Prevent double initialization
    if (window._dropdownInitialized) return;
    window._dropdownInitialized = true;

    function initDropdown() {
        const header = document.querySelector('.gl-custom-header');
        if (!header) return;
        
        // Already processed? Skip
        if (header.dataset.dropdownDone === 'true') return;
        
        const nav = header.querySelector('.gh-navigation-menu .nav');
        if (!nav) return;

        const items = Array.from(nav.children);
        if (!items.length) return;

        // Mark as processing
        header.dataset.dropdownDone = 'true';

        // Group items: "#" prefix = sub-item of previous
        const groups = [];
        let currentParent = null;

        items.forEach(li => {
            const link = li.querySelector('a');
            if (!link) return;

            const text = link.textContent.trim();
            const isSub = text.startsWith('#');

            if (isSub && currentParent) {
                if (!currentParent.subs) currentParent.subs = [];
                currentParent.subs.push({
                    text: text.replace(/^#\s*/, ''),
                    url: link.href,
                    classes: li.className
                });
            } else {
                if (currentParent) groups.push(currentParent);
                currentParent = {
                    text: isSub ? text.replace(/^#\s*/, '') : text,
                    url: link.href,
                    classes: li.className,
                    subs: []
                };
            }
        });
        if (currentParent) groups.push(currentParent);

        // Rebuild navigation
        nav.innerHTML = '';

        groups.forEach(item => {
            const li = document.createElement('li');
            li.className = item.classes;

            if (item.subs && item.subs.length) {
                li.classList.add('has-dropdown');
                
                const a = document.createElement('a');
                a.href = item.url;
                a.className = 'nav-link-parent';
                a.innerHTML = item.text + ' <svg class="dropdown-icon" width="10" height="10" viewBox="0 0 10 10"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                li.appendChild(a);

                const ul = document.createElement('ul');
                ul.className = 'dropdown-menu';
                item.subs.forEach(sub => {
                    const subLi = document.createElement('li');
                    const subA = document.createElement('a');
                    subA.href = sub.url;
                    subA.textContent = sub.text;
                    subLi.appendChild(subA);
                    ul.appendChild(subLi);
                });
                li.appendChild(ul);
            } else {
                const a = document.createElement('a');
                a.href = item.url;
                a.textContent = item.text;
                li.appendChild(a);
            }

            nav.appendChild(li);
        });

        header.classList.add('is-dropdown-loaded');
        
        // Mobile: click to toggle dropdown
        const dropdownItems = nav.querySelectorAll('li.has-dropdown');
        dropdownItems.forEach(item => {
            const link = item.querySelector('.nav-link-parent');
            if (link) {
                link.addEventListener('click', function(e) {
                    // Only prevent default on mobile
                    if (window.innerWidth < 768) {
                        e.preventDefault();
                        item.classList.toggle('is-open');
                        // Close others
                        dropdownItems.forEach(other => {
                            if (other !== item) other.classList.remove('is-open');
                        });
                    }
                });
            }
        });
    }

    // Initialize once
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDropdown);
    } else {
        initDropdown();
    }
})();
